import { defineStore } from 'pinia'
import {removeToken } from '@/utils/auth';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user')) || null, // 从 localStorage 恢复用户信息
    token: localStorage.getItem('token') || null,          // 从 localStorage 恢复 token
    isLoading: false,                                      // 加载状态
    admin: localStorage.getItem('admin') === 'true',
  }),
  
  getters: {
    isLoggedIn: (state) => !!state.token,                  // 判断用户是否已登录
    username: (state) => state.user,       // 获取用户名
    isAdmin:(state)=>state.admin,
  },
  
  actions: {
    // 登出逻辑
    logoutAction() {
      try {
        // 调用登出 API（当前无后端登出接口，仅清理本地状态）
      } catch (error) {
        console.error('登出失败:', error);
      } finally {
        this.token = null;
        this.user = null;
        removeToken();
        // 清除 localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('admin');
      }
    },

    // 恢复用户信息（可选，应用初始化时调用）
    restoreUser() {
      this.token = localStorage.getItem('token');
      this.user = JSON.parse(localStorage.getItem('user'));
    },
  },
});
